// data is supposed to be really all product/product line related data for the whole page
export default () => ({
    slug: '',
    productLineSlug: '',
    fromAd: false,
    defaultData: {},
    originalSku: '',
    mismatchedProduct: null,
    data: {
        name: '',
        gallery: [],
        basePrice: {},
        actualPrice: {},
        warranty: {},
        howItWorks: [],
        promo: null,
        shipping: {},
        qtySelector: {
            default: 1,
            enabled: false, // seems to be needed for reactivity at least for single part ordering (extang-tonno-tonic-cleaner)
        },
        sku: '', // product
    },
    controls: {
        drills: [],
        groups: [],
        drillConfig: {
            all: [],
            top: [],
            bottom: [],
            splitAt: '',
            fitment: [],
            lastFitment: null,
            integration: {},
        },
        isGoodVehicleSoFar: true,
        isShortCutFitment: false,
        hasOrderControlError: false,
        hasInteraction: false,
    },
})
